module.exports = __webpack_public_path__ + "img/lr-cb66-001.c11ed201.gif";